var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    viewBox: "0 0 20 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0H3C1.34375 0 0 1.17578 0 2.625V25.375C0 26.8242 1.34375 28 3 28H17C18.6562 28 20 26.8242 20 25.375V2.625C20 1.17578 18.6562 0 17 0ZM10 26.25C8.89375 26.25 8 25.468 8 24.5C8 23.532 8.89375 22.75 10 22.75C11.1063 22.75 12 23.532 12 24.5C12 25.468 11.1063 26.25 10 26.25ZM17 20.3438C17 20.7047 16.6625 21 16.25 21H3.75C3.3375 21 3 20.7047 3 20.3438V3.28125C3 2.92031 3.3375 2.625 3.75 2.625H16.25C16.6625 2.625 17 2.92031 17 3.28125V20.3438Z",
    fill: "#808282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/MobileIcon.5e1f70ca33a89aab7250955414c29681.svg";
export { ForwardRef as ReactComponent };